import { Alert, Well, FormControl, Button, Panel, Row, Col, FormGroup, ControlLabel } from 'react-bootstrap';
import { IFilter } from './filter';
import { IListItem } from '@nkr/models/index';
import { PrimaryGoalType } from '@nkr/enums/index';
import { PatientIntakeReferralStatus, PatientIntakeRegistationStatus } from '@nkr/enums/patient-intake-referral-status';
import { FilterWrapper } from './styles';
import { PatientIntakeTabs } from './nav';
import { useContext } from 'react';
import { PatientIntakeContext } from './context';

interface IProps {
    filter?: IFilter,
    // isAdminView: boolean,
    // centerList: IListItem[],
    sourceList: string[],
    // primaryGoalList: IListItem[],
    // registrationStatusList: IListItem[],
    currentTab: PatientIntakeTabs,
    onFilterChange: (field: string, value: any) => void,
    onSearch: () => void,
    onClear: () => void,
    onExport: () => void,
}

const PatientIntakeFilter = ({ filter = {}, sourceList, currentTab, onFilterChange, onSearch, onClear, onExport }: IProps) => {
    const context = useContext(PatientIntakeContext);
    
    const handleKeyDown = (e: React.KeyboardEvent<FormControl>): void => {
        if (e.key === 'Enter') {
            e.preventDefault();
            onSearch();
        }
    };

    const handleInputChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        let { name, value } = e.currentTarget;

        if (name === 'center' || name === 'primaryGoal' || name == 'registrationStatus' || name == 'referralStatus') {
            onFilterChange(name, parseInt(value));
        } else {
            onFilterChange(name, value);
        }
    };

    return (
        <FilterWrapper style={{ padding: 9.5 }}>
            <Row>
                <Col md={6} style={{ display: 'center', alignItems: 'center' }}>
                    <Alert bsSize='sm'>
                        <FormGroup bsSize='sm' style={{ display: 'ruby', alignItems: 'center' }}>
                            <ControlLabel>Search Registration Date Between:&nbsp;</ControlLabel>
                            <FormControl
                                style={{ width: '25%' }}
                                type='date'
                                name='registrationDateFrom'
                                placeholder='Registration Date From'
                                value={filter.registrationDateFrom || ''}
                                onChange={handleInputChange}
                            />
                            <ControlLabel>&nbsp;and:&nbsp;</ControlLabel>
                            <FormControl
                                style={{ width: '25%' }}
                                type='date'
                                name='registrationDateTo'
                                placeholder='Registration Date To'
                                value={filter.registrationDateTo || ''}
                                onChange={handleInputChange}
                            />
                        </FormGroup>
                    </Alert>
                </Col>
                <Col md={6}>
                    {currentTab == PatientIntakeTabs.ALL && (
                        <div style={{ width: '100%', textAlign: 'end' }}>
                            <span className='bg-warning' style={{ padding: 3 }}>WARNING: For the ALL tab, the first 500 records will be retrieved, please use criteria to narrow down your search...</span>
                        </div>
                    )}
                </Col>
            </Row>

            <Row>
                <Col md={2}>
                    <FormGroup>
                        <ControlLabel>First Name</ControlLabel>
                        <FormControl
                            type='text'
                            name='firstName'
                            placeholder='First Name'
                            value={filter.firstName || ''}
                            onChange={handleInputChange}
                            onKeyDown={handleKeyDown}
                        />
                    </FormGroup>
                </Col>

                <Col md={2}>
                    <FormGroup>
                        <ControlLabel>Last Name</ControlLabel>
                        <FormControl
                            type='text'
                            name='lastName'
                            placeholder='Last Name'
                            value={filter.lastName || ''}
                            onChange={handleInputChange}
                            onKeyDown={handleKeyDown}
                        />
                    </FormGroup>
                </Col>

                <Col md={2}>
                    <FormGroup>
                        <ControlLabel>Email</ControlLabel>
                        <FormControl
                            type='text'
                            name='email'
                            placeholder='Email'
                            value={filter.email || ''}
                            onChange={handleInputChange}
                            onKeyDown={handleKeyDown}
                        />
                    </FormGroup>
                </Col>

                <Col md={2}>
                    <FormGroup>
                        <ControlLabel>Date of Birth</ControlLabel>
                        <FormControl
                            type='date'
                            name='dateOfBirth'
                            placeholder='Date of Birth'
                            value={filter.dateOfBirth || ''}
                            onChange={handleInputChange}
                        />
                    </FormGroup>
                </Col>
            </Row>

            <Row>
                <Col md={2}>
                    <FormGroup>
                        <ControlLabel>Primary Goal</ControlLabel>
                        <FormControl
                            componentClass='select'
                            name='primaryGoal'
                            value={filter.primaryGoal}
                            onChange={handleInputChange}
                        >
                            <option value={null}>- All Goals -</option>
                            {context.primaryGoalList.map(item =>
                                <option key={'pg-' + item.id} value={item.id}>{item.description}</option>
                            )}
                        </FormControl>
                    </FormGroup>
                </Col>


                <Col md={2}>
                    <FormGroup>
                        <ControlLabel>Registration Status</ControlLabel>
                        <FormControl
                            componentClass='select'
                            name='registrationStatus'
                            value={filter.registrationStatus}
                            onChange={handleInputChange}
                        >
                            <option value={null}>- All -</option>
                            {context.registrationStatusList.map(item =>
                                <option key={'reg-st-' + item.id} value={item.id}>{item.description}</option>
                            )}
                        </FormControl>
                    </FormGroup>
                </Col>

                <Col md={2}>
                    <FormGroup>
                        <ControlLabel>Referral Status</ControlLabel>
                        <FormControl
                            componentClass='select'
                            name='referralStatus'
                            value={filter.referralStatus}
                            onChange={handleInputChange}
                        >
                            <option value={null}>- All -</option>
                            {context.referralStatusList.map(item =>
                                <option key={'ref-st-' + item.id} value={item.id}>{item.description}</option>
                            )}
                        </FormControl>
                    </FormGroup>
                </Col>

                <Col md={3} className='text-left' style={{ paddingTop: 20 }}>
                    <Button bsStyle='primary' onClick={onSearch} style={{ marginRight: 10 }}>Search</Button>
                    <Button bsStyle='success' onClick={onExport} style={{ marginRight: 10 }}>Export</Button>
                    <Button onClick={onClear}>Clear Filters</Button>
                </Col>
            </Row>

            {context.isAdminView && (
                <Row>
                    <Col md={8}>
                        <Panel style={{ marginBottom: 0 }}>
                            <Panel.Body>
                                <div className='container-fluid'>
                                    <Row>
                                        <Col md={1} style={{ textAlign: 'center' }}><h4>ADMIN ONLY</h4></Col>
                                        <Col md={3}>
                                            <FormGroup style={{ marginBottom: 0 }}>
                                                <ControlLabel>Center</ControlLabel>
                                                <FormControl
                                                    componentClass='select'
                                                    name='center'
                                                    value={filter.center}
                                                    onChange={handleInputChange}
                                                >
                                                    <option value={-1}>- All Centers -</option>
                                                    <option value={0}>- No Center -</option>
                                                    {context.centerList.map(item =>
                                                        <option key={'ctr-' + item.id} value={item.id}>{item.description}</option>
                                                    )}
                                                </FormControl>
                                            </FormGroup>
                                        </Col>

                                        <Col md={3}>
                                            <FormGroup style={{ marginBottom: 0 }}>
                                                <ControlLabel>Source</ControlLabel>
                                                <FormControl
                                                    componentClass='select'
                                                    name='source'
                                                    value={filter.source || ''}
                                                    onChange={handleInputChange}
                                                >
                                                    <option value=''>- All Sources -</option>
                                                    {sourceList.map(source =>
                                                        <option key={`src-${source}`} value={source}>{source}</option>
                                                    )}
                                                </FormControl>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </div>
                            </Panel.Body>
                        </Panel>
                    </Col>
                </Row>
            )}
        </FilterWrapper>
    );
};

export default PatientIntakeFilter;